import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["rating", "size"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo } from 'react';
import { Rating as FlowRiteRating } from 'flowbite-react';
import { ratingNumberRange, getRange } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
var FlowRiteRatingStar = FlowRiteRating.Star;
export function Rating(_ref) {
  var _ref$rating = _ref.rating,
      rating = _ref$rating === void 0 ? 0 : _ref$rating,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var reviewRatingRange = useMemo(function () {
    try {
      return getRange(Number(rating.toFixed()));
    } catch (error) {
      return [];
    }
  }, [rating]);
  var ratingStarEl = useMemo(function () {
    return ratingNumberRange.map(function (v) {
      return /*#__PURE__*/_jsx(StyledFlowRiteRatingStar, {
        filled: reviewRatingRange.includes(v)
      }, v);
    });
  }, [reviewRatingRange]);
  return /*#__PURE__*/_jsx(StyledFlowRiteRating, _objectSpread(_objectSpread({
    size: size
  }, rest), {}, {
    children: ratingStarEl
  }));
}
export default Rating;

var StyledFlowRiteRating = /*#__PURE__*/_styled(FlowRiteRating).withConfig({
  displayName: "rating__StyledFlowRiteRating",
  componentId: "sc-smge16-0"
})({});

var StyledFlowRiteRatingStar = /*#__PURE__*/_styled(FlowRiteRatingStar).withConfig({
  displayName: "rating__StyledFlowRiteRatingStar",
  componentId: "sc-smge16-1"
})(["", ""], function (_ref2) {
  var filled = _ref2.filled;
  return filled ? {
    "--tw-text-opacity": "1",
    "color": "rgb(250 202 21 / var(--tw-text-opacity))"
  } : '';
});